import { render, staticRenderFns } from "./Labs.vue?vue&type=template&id=0de64ba2&scoped=true&"
import script from "./Labs.vue?vue&type=script&lang=ts&"
export * from "./Labs.vue?vue&type=script&lang=ts&"
import style0 from "./Labs.vue?vue&type=style&index=0&id=0de64ba2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de64ba2",
  null
  
)

export default component.exports